import { Skeleton, Stack, Typography, useTheme } from "@mui/material";

interface HeaderPopoverInfoStack {
  label: string;
  value?: string | number;
  loading?: boolean;
}

/**
 * Component for a single value for a field. Shows a skeleton placeholder if the value is undefined.
 * Created because the rank and BYB IQ sections in the header popover are identical in style.
 * @param value e.g. 820 for BYB IQ.
 * @param label e.g. BYB IQ.
 * @param loading Whether the value is still loading.
 * @returns
 */
const HeaderPopoverInfoStack = ({ value, label, loading }: HeaderPopoverInfoStack) => {
  const theme = useTheme();
  return (
    <Stack spacing={1.75} sx={{ padding: theme.spacing(1.75, 0, 2), alignItems: "center" }}>
      <Stack spacing={0.5} sx={{ alignItems: "center" }}>
        {!loading ? (
          <Typography variant="text2xl700" color="dsBase.v200">
            {value ?? "-"}
          </Typography>
        ) : (
          <Skeleton variant="rounded" width={100} height={24} />
        )}
        <Typography variant="textBase500" color="dsNeutral.v200">
          {label}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default HeaderPopoverInfoStack;
